const MOCK_STANDARD = `
<h1 style="text-align:center; margin-bottom:24px;">ASSURED SHORTHOLD TENANCY AGREEMENT</h1>
<h2 style="text-align:center; margin-bottom:32px;">Periodic Tenancy - Standard Tier</h2>

<h3>1. PARTIES</h3>
<p><strong>Landlord:</strong> Jane Smith, 45 Victoria Road, London, SW1A 1AA</p>
<p><strong>Tenant:</strong> John Doe, nominated tenant</p>

<h3>2. PROPERTY</h3>
<p>The property known as <strong>12 Oak Lane, Flat 3, Manchester, M1 2AB</strong> ("the Property"), including all fixtures and fittings as detailed in the inventory.</p>

<h3>3. TERM</h3>
<p>This tenancy is a <strong>periodic tenancy</strong> running on a monthly basis from <strong>1 April 2025</strong> in accordance with the Renters' Rights Bill 2025 provisions.</p>

<h3>4. RENT</h3>
<p>The rent is <strong>&pound;1,200.00 per calendar month</strong>, payable in advance on the 1st day of each month by standing order to the Landlord's designated bank account.</p>

<h3>5. DEPOSIT</h3>
<p>A deposit of <strong>&pound;1,200.00</strong> (equivalent to five weeks' rent) has been taken and will be protected in a government-approved tenancy deposit scheme within 30 days of receipt, in accordance with the Housing Act 2004.</p>

<h3>6. TENANT OBLIGATIONS</h3>
<ul>
<li>Pay the rent on time and in full</li>
<li>Keep the Property in a clean and reasonable condition</li>
<li>Not cause nuisance or annoyance to neighbours</li>
<li>Not make alterations without written consent</li>
<li>Allow reasonable access for inspections with 24 hours' notice</li>
</ul>

<h3>7. LANDLORD OBLIGATIONS</h3>
<ul>
<li>Maintain the structure and exterior of the Property</li>
<li>Keep installations for water, gas, electricity and sanitation in working order</li>
<li>Ensure the Property meets the Decent Homes Standard</li>
<li>Provide a valid Energy Performance Certificate</li>
<li>Comply with the Homes (Fitness for Human Habitation) Act 2018</li>
</ul>

<h3>8. TERMINATION</h3>
<p>Either party may terminate this agreement by giving not less than <strong>two months' written notice</strong> (landlord) or <strong>one month's written notice</strong> (tenant), in accordance with current legislation.</p>

<h3>9. GOVERNING LAW</h3>
<p>This agreement is governed by and construed in accordance with the laws of England and Wales.</p>

<p style="margin-top:48px;"><strong>Signed by the Landlord:</strong> ____________________________</p>
<p><strong>Signed by the Tenant:</strong> ____________________________</p>
<p><strong>Date:</strong> ____________________________</p>
`;

const MOCK_ENHANCED = `
<h1 style="text-align:center; margin-bottom:24px;">ASSURED SHORTHOLD TENANCY AGREEMENT</h1>
<h2 style="text-align:center; margin-bottom:8px;">Periodic Tenancy - Enhanced Tier</h2>
<p style="text-align:center; color:#666; margin-bottom:32px;">Comprehensive Legal Protection Edition</p>

<h3>1. PARTIES</h3>
<p><strong>Landlord:</strong> Jane Smith, 45 Victoria Road, London, SW1A 1AA</p>
<p><strong>Tenant:</strong> John Doe, nominated tenant</p>

<h3>2. PROPERTY</h3>
<p>The property known as <strong>12 Oak Lane, Flat 3, Manchester, M1 2AB</strong> ("the Property"), including all fixtures, fittings, furniture and contents as detailed in the attached inventory and schedule of condition.</p>

<h3>3. TERM</h3>
<p>This tenancy is a <strong>periodic tenancy</strong> running on a monthly basis from <strong>1 April 2025</strong> in accordance with the Renters' Rights Bill 2025 provisions. This agreement supersedes any prior arrangements between the parties.</p>

<h3>4. RENT</h3>
<p>The rent is <strong>&pound;1,200.00 per calendar month</strong>, payable in advance on the 1st day of each month by standing order. Any rent increase shall comply with the Renters' Rights Bill provisions regarding market rate assessments and tribunal referral rights.</p>

<h3>5. DEPOSIT</h3>
<p>A deposit of <strong>&pound;1,200.00</strong> has been taken and protected under the Deposit Protection Service (DPS). The Prescribed Information has been served to the Tenant within 30 days of receipt. Deductions shall only be made in accordance with the deposit scheme's dispute resolution process.</p>

<h3>6. TENANT OBLIGATIONS</h3>
<ul>
<li>Pay the rent on time and in full</li>
<li>Keep the Property in a clean and reasonable condition</li>
<li>Not cause nuisance or annoyance to neighbours</li>
<li>Not make alterations without prior written consent</li>
<li>Allow reasonable access for inspections with minimum 24 hours' written notice</li>
<li>Report any disrepair or defect promptly in writing</li>
<li>Comply with all obligations under the tenancy and applicable legislation</li>
<li>Not keep pets without prior written consent from the Landlord</li>
</ul>

<h3>7. LANDLORD OBLIGATIONS</h3>
<ul>
<li>Maintain the structure and exterior of the Property</li>
<li>Keep installations for water, gas, electricity and sanitation in working order</li>
<li>Ensure the Property meets the Decent Homes Standard</li>
<li>Provide valid Gas Safety Certificate, EICR, and EPC</li>
<li>Comply with the Homes (Fitness for Human Habitation) Act 2018</li>
<li>Protect the deposit and serve Prescribed Information within statutory timeframes</li>
<li>Not harass or unlawfully evict the Tenant</li>
<li>Carry out repairs within a reasonable timeframe after notification</li>
</ul>

<h3>8. REPAIRS AND MAINTENANCE</h3>
<p>The Landlord shall respond to urgent repair requests within 24 hours and non-urgent repairs within 14 days. The Tenant is responsible for minor maintenance tasks and keeping the Property clean.</p>

<h3>9. INSURANCE</h3>
<p>The Landlord shall maintain buildings insurance. The Tenant is responsible for insuring their own contents and personal belongings.</p>

<h3>10. TERMINATION</h3>
<p>The Landlord may terminate by giving not less than <strong>two months' written notice</strong> on valid grounds as specified under the Renters' Rights Bill 2025. The Tenant may terminate by giving <strong>one month's written notice</strong>.</p>

<h3>11. DISPUTE RESOLUTION</h3>
<p>The parties agree to attempt mediation through a recognised service before commencing court proceedings, except in cases of urgency or where possession is sought on mandatory grounds.</p>

<h3>12. GOVERNING LAW</h3>
<p>This agreement is governed by the laws of England and Wales.</p>

<p style="margin-top:48px;"><strong>Signed by the Landlord:</strong> ____________________________</p>
<p><strong>Signed by the Tenant:</strong> ____________________________</p>
<p><strong>Date:</strong> ____________________________</p>
`;

const MOCK_PREMIUM = `
<h1 style="text-align:center; margin-bottom:24px;">ASSURED SHORTHOLD TENANCY AGREEMENT</h1>
<h2 style="text-align:center; margin-bottom:8px;">Periodic Tenancy - Premium Tier</h2>
<p style="text-align:center; color:#666; margin-bottom:32px;">Complete Legal Protection &amp; Compliance Suite</p>

<h3>1. INTERPRETATION AND DEFINITIONS</h3>
<p>In this Agreement, unless the context otherwise requires:</p>
<ul>
<li><strong>"the Act"</strong> means the Housing Act 1988 as amended</li>
<li><strong>"the Property"</strong> means the dwelling and all fixtures and fittings therein</li>
<li><strong>"the Landlord"</strong> means the person named below and includes successors in title</li>
<li><strong>"the Tenant"</strong> means the person(s) named below</li>
<li><strong>"the Deposit"</strong> means the sum held as security under this Agreement</li>
<li><strong>"Renters' Rights Bill"</strong> means the Renters' Rights Bill 2025 and all secondary legislation made thereunder</li>
</ul>

<h3>2. PARTIES</h3>
<p><strong>Landlord:</strong> Jane Smith, 45 Victoria Road, London, SW1A 1AA</p>
<p><strong>Tenant:</strong> John Doe, nominated tenant</p>
<p><strong>Managing Agent (if applicable):</strong> N/A</p>

<h3>3. PROPERTY</h3>
<p>The property known as <strong>12 Oak Lane, Flat 3, Manchester, M1 2AB</strong> together with all fixtures, fittings, furniture, equipment and contents as detailed in the attached inventory and schedule of condition, which has been signed by both parties.</p>

<h3>4. TERM AND COMMENCEMENT</h3>
<p>This tenancy is a <strong>periodic tenancy</strong> commencing on <strong>1 April 2025</strong> and continuing on a monthly basis until lawfully terminated by either party in accordance with this Agreement and applicable legislation including the Renters' Rights Bill 2025.</p>

<h3>5. RENT AND PAYMENT</h3>
<p>5.1 The rent is <strong>&pound;1,200.00 per calendar month</strong>, payable in advance on the 1st day of each month.</p>
<p>5.2 Payment shall be made by standing order to the Landlord's designated account.</p>
<p>5.3 Any rent increase shall comply with the Renters' Rights Bill provisions regarding market rate assessments, with the Tenant retaining the right to refer any proposed increase to the First-tier Tribunal (Property Chamber).</p>
<p>5.4 The Landlord may not increase rent more than once in any 12-month period.</p>

<h3>6. DEPOSIT PROTECTION</h3>
<p>6.1 A deposit of <strong>&pound;1,200.00</strong> (not exceeding five weeks' rent) has been received and shall be protected under the Deposit Protection Service (DPS) within 30 days of receipt.</p>
<p>6.2 The Prescribed Information under Schedule 10 of the Housing Act 2004 shall be served within 30 days.</p>
<p>6.3 At the end of the tenancy, the deposit shall be returned within 10 days of agreement on deductions, or referred to the scheme's Alternative Dispute Resolution service.</p>

<h3>7. TENANT OBLIGATIONS</h3>
<p>The Tenant agrees to:</p>
<ul>
<li>Pay the rent punctually and in full on the due date</li>
<li>Keep the interior of the Property in a clean and reasonable condition</li>
<li>Not cause or permit any nuisance, annoyance or disturbance to neighbours</li>
<li>Not make any structural or decorative alterations without prior written consent</li>
<li>Allow reasonable access for inspections with minimum 24 hours' written notice</li>
<li>Promptly report in writing any disrepair, defect or damage to the Property</li>
<li>Use the Property as a single private dwelling only</li>
<li>Not assign, sublet or part with possession without written consent</li>
<li>Comply with all statutory obligations and conditions of any superior lease</li>
<li>Not keep any pets without prior written consent (which shall not be unreasonably withheld)</li>
<li>Take reasonable steps to prevent condensation and mould growth</li>
<li>Return the Property at the end of the tenancy in the condition recorded in the inventory, fair wear and tear excepted</li>
</ul>

<h3>8. LANDLORD OBLIGATIONS</h3>
<p>The Landlord agrees to:</p>
<ul>
<li>Maintain the structure and exterior of the Property (Section 11, Landlord and Tenant Act 1985)</li>
<li>Keep in repair and proper working order all installations for water, gas, electricity, sanitation, space heating and hot water</li>
<li>Ensure the Property meets the Decent Homes Standard and Fitness for Human Habitation requirements</li>
<li>Provide and maintain valid Gas Safety Certificate (annually), EICR (every 5 years), and EPC</li>
<li>Install and maintain working smoke alarms and carbon monoxide detectors</li>
<li>Protect the deposit and serve all required notices within statutory timeframes</li>
<li>Not harass or unlawfully evict the Tenant</li>
<li>Carry out emergency repairs within 24 hours and routine repairs within 28 days</li>
<li>Provide the Tenant with the Landlord's name and address for service of notices</li>
<li>Comply with all requirements of the Renters' Rights Bill 2025</li>
</ul>

<h3>9. REPAIRS, MAINTENANCE AND PROPERTY STANDARDS</h3>
<p>9.1 The Landlord shall maintain the Property to at least the Decent Homes Standard.</p>
<p>9.2 Emergency repairs (risk to health/safety): response within 24 hours.</p>
<p>9.3 Urgent repairs (no hot water/heating): response within 48 hours.</p>
<p>9.4 Routine repairs: completed within 28 days of notification.</p>
<p>9.5 The Tenant shall allow access for repairs at reasonable times with appropriate notice.</p>

<h3>10. INSURANCE</h3>
<p>10.1 The Landlord shall maintain adequate buildings insurance for the Property.</p>
<p>10.2 The Tenant is responsible for insuring personal belongings and contents.</p>
<p>10.3 Neither party shall do anything that invalidates the other's insurance.</p>

<h3>11. ANTI-SOCIAL BEHAVIOUR</h3>
<p>The Tenant and their household members and visitors shall not engage in any anti-social behaviour that causes or is likely to cause nuisance, annoyance, harassment, alarm or distress to any person in the locality.</p>

<h3>12. TERMINATION</h3>
<p>12.1 The Landlord may seek possession only on grounds specified in the Renters' Rights Bill 2025, with the required notice period (minimum two months for most grounds).</p>
<p>12.2 The Tenant may end the tenancy by giving at least one month's written notice.</p>
<p>12.3 Any notice must be in writing and served in accordance with Section 196 of the Law of Property Act 1925.</p>

<h3>13. DISPUTE RESOLUTION</h3>
<p>13.1 The parties shall attempt to resolve any dispute through direct negotiation in the first instance.</p>
<p>13.2 If negotiation fails, the parties agree to engage in mediation through a recognised mediation service before commencing court proceedings.</p>
<p>13.3 Nothing in this clause prevents either party from seeking emergency relief from the courts.</p>

<h3>14. DATA PROTECTION</h3>
<p>Both parties shall comply with the UK General Data Protection Regulation and the Data Protection Act 2018 in relation to any personal data processed in connection with this tenancy.</p>

<h3>15. GOVERNING LAW AND JURISDICTION</h3>
<p>This Agreement is governed by and construed in accordance with the laws of England and Wales. The parties submit to the exclusive jurisdiction of the courts of England and Wales.</p>

<h3>16. ENTIRE AGREEMENT</h3>
<p>This Agreement constitutes the entire agreement between the parties and supersedes all prior discussions, negotiations and agreements relating to its subject matter.</p>

<p style="margin-top:48px;"><strong>Signed by the Landlord:</strong> ____________________________</p>
<p><strong>Date:</strong> ____________________________</p>
<p style="margin-top:16px;"><strong>Signed by the Tenant:</strong> ____________________________</p>
<p><strong>Date:</strong> ____________________________</p>
<p style="margin-top:16px;"><strong>Witnessed by:</strong> ____________________________</p>
<p><strong>Date:</strong> ____________________________</p>
`;

export const mockAgreements = {
  standard: MOCK_STANDARD,
  enhanced: MOCK_ENHANCED,
  premium: MOCK_PREMIUM,
};
